/* eslint-disable no-undef */
import { hotjar } from "react-hotjar"

export const initializeHotjar = () => {
    hotjar.initialize(process.env.NEXT_PUBLIC_HJID, process.env.NEXT_PUBLIC_SJSV)
}
